import React, { useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const LanguageToggle = () => {
  const { language, toggleLanguage } = useLanguage();
  const [isFlipping, setIsFlipping] = useState(false);

  const handleClick = () => {
    if (isFlipping) return;
    setIsFlipping(true);
    toggleLanguage();
    // Reset after animation
    setTimeout(() => setIsFlipping(false), 600);
  };

  return (
    <button
      onClick={handleClick}
      data-testid="language-toggle-btn"
      className="fixed bottom-20 right-6 z-50 w-14 h-14 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 group"
      title={language === 'es' ? 'Mudar para Português' : 'Cambiar a Español'}
      aria-label={language === 'es' ? 'Mudar para Português' : 'Cambiar a Español'}
      style={{ perspective: '1000px' }}
    >
      {/* Coin container */}
      <div 
        className="relative w-full h-full"
        style={{
          transformStyle: 'preserve-3d',
          transform: language === 'pt' ? 'rotateY(180deg)' : 'rotateY(0deg)',
          transition: 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)'
        }}
      >
        {/* Argentina face (front) */}
        <div 
          className="absolute inset-0 rounded-full overflow-hidden border-3 border-white shadow-md bg-gradient-to-br from-sky-300 to-sky-500"
          style={{ 
            backfaceVisibility: 'hidden',
            WebkitBackfaceVisibility: 'hidden'
          }}
        >
          <img 
            src="https://flagcdn.com/w160/ar.png" 
            alt="Español (Argentina)" 
            className="w-full h-full object-cover"
            loading="lazy"
          />
          {/* Shine effect */}
          <div className="absolute inset-0 bg-gradient-to-br from-white/30 via-transparent to-transparent rounded-full pointer-events-none" />
        </div>
        
        {/* Brazil face (back) */}
        <div 
          className="absolute inset-0 rounded-full overflow-hidden border-3 border-white shadow-md bg-gradient-to-br from-green-400 to-green-600"
          style={{ 
            backfaceVisibility: 'hidden',
            WebkitBackfaceVisibility: 'hidden',
            transform: 'rotateY(180deg)'
          }}
        >
          <img 
            src="https://flagcdn.com/w160/br.png" 
            alt="Português (Brasil)" 
            className="w-full h-full object-cover"
            loading="lazy"
          />
          {/* Shine effect */}
          <div className="absolute inset-0 bg-gradient-to-br from-white/30 via-transparent to-transparent rounded-full pointer-events-none" />
        </div>
      </div>
      
      {/* Ring animation on hover */}
      <div className="absolute inset-0 rounded-full border-2 border-teal-400/0 group-hover:border-teal-400/50 group-hover:scale-110 transition-all duration-300" />
      
      {/* Tooltip */}
      <span 
        className="absolute -top-10 left-1/2 transform -translate-x-1/2 bg-slate-800 text-white text-xs px-3 py-1.5 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap shadow-lg"
        data-testid="language-toggle-tooltip"
      >
        {language === 'es' ? '🇧🇷 Português' : '🇦🇷 Español'}
        <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 rotate-45 w-2 h-2 bg-slate-800" />
      </span>
    </button>
  );
};

export default LanguageToggle;
